<div class="access-denied-container">
  <h1>Acceso denegado</h1>
  <p>No tienes permisos para acceder a esta sección de la aplicación.</p>
  <a routerLink="/" class="go-home">Volver al inicio</a>
</div>
